import PropTypes from 'prop-types';
import React from 'react';
import ButtonV2 from '../ButtonV2';
import {
  ActionButtons,
  FilterButtonWrapper,
  ActiveIndicator,
} from './StyledComponents';

const FilterIcon = () => (
  <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
    <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z" />
  </svg>
);

const ClearFilterIcon = () => (
  <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
    />
    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
  </svg>
);

/**
 * TableActionButton - A reusable filter/clear button component for tables
 *
 * @param {Function} onFilterClick - Callback when filter button is clicked
 * @param {Function} onClearClick - Callback when clear button is clicked (optional, shows clear button if provided)
 * @param {boolean} hasActiveFilters - Whether filters are currently applied (shows indicator dot)
 *
 * @example
 * // Basic usage with filter only
 * <TableActionButton onFilterClick={handleFilterClick} />
 *
 * @example
 * // With clear button and active indicator
 * <TableActionButton
 *   onFilterClick={handleFilterClick}
 *   onClearClick={handleClearClick}
 *   hasActiveFilters={true}
 * />
 */
const TableActionButton = ({
  onFilterClick,
  onClearClick,
  hasActiveFilters = false,
}) => {
  return (
    <ActionButtons>
      {onClearClick && (
        <ButtonV2
          variant="icon"
          title="Clear Filters"
          onClick={onClearClick}
          icon={<ClearFilterIcon />}
        />
      )}
      <FilterButtonWrapper>
        <ButtonV2
          variant="icon"
          title="Filter"
          onClick={onFilterClick}
          icon={<FilterIcon />}
        />
        {hasActiveFilters && <ActiveIndicator />}
      </FilterButtonWrapper>
    </ActionButtons>
  );
};

TableActionButton.propTypes = {
  onFilterClick: PropTypes.func.isRequired,
  onClearClick: PropTypes.func,
  hasActiveFilters: PropTypes.bool,
};

export default TableActionButton;

// Export icons for external use
export { FilterIcon, ClearFilterIcon };
